import { gql } from '@apollo/client';

export const GET_CORPORATE_INFO = gql`
  mutation GetCorporateInfo($corporateNumber: String!) {
    getCorporateInfoFromCorporateNumber(corporateNumber: $corporateNumber) {
      name
      address
    }
  }
`;
